module.exports = __webpack_public_path__ + "img/logo.15df9104.png";